import { type CSSProperties } from 'react';

export interface Layout {
  column: number;
  row: number;
  height: number;
  width: number;
}

export interface GridStyles {
  label: CSSProperties;
  input: CSSProperties;
  container: CSSProperties;
}

interface CalculateGridStylesOptions {
  layout: Layout;
}

export function calculateGridStyles(
  options: CalculateGridStylesOptions,
): GridStyles {
  const { layout } = options;
  const gridColumn = `${layout.column + 1} / span ${layout.width}`;

  return {
    label: {
      gridRow: '1 / span 1',
      gridColumn,
      display: 'flex',
      alignItems: 'flex-end',
    },
    input: {
      gridRow: '2 / span 1',
      gridColumn,
    },
    container: {
      gridRow: '1 / span 2',
      gridColumn,
    },
  };
}
